// extracted by mini-css-extract-plugin
export default {"simplePopoverForm":"styles_simplePopoverForm__DV7-D"};